import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { FaEye, FaFileUpload, FaTrash } from "react-icons/fa";
// import PDFViewer from "./PdfViewer"; // Import the PDFViewer component
import { RiQuestionnaireFill } from "react-icons/ri";
import "./faqpdf.css"
import { toast } from "react-toastify";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { Base_Url } from "../config";
import { selectUserExists } from "../redux/userSlice";
import { useSelector } from "react-redux";

const FaqPdfTable = () => {
    const [faqData, setFaqData] = useState([]);
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [showPdfViewer, setShowPdfViewer] = useState(false);

    const getfaqPdfs = () => {
        fetch(`${Base_Url}/faq-pdfs`)
            .then((response) => response.json())
            .then((data) => {
                // console.log(data)
                setFaqData(data.cscuploads);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };


    const userExists = useSelector(selectUserExists);
    useEffect(() => {
        // Fetch data from the API
        getfaqPdfs();
    }, []); // Empty dependency array ensures useEffect runs only once on component mount

    const handleUploadButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const uploadFile = async () => {
        try {
            if (!selectedFile) {
                throw new Error("No file selected");
            }

            const formData = new FormData();
            formData.append("file", selectedFile);

            const uploadResponse = await fetch(`${Base_Url}/uploadPdfFaq`, {
                method: "POST",
                body: formData,
            });

            if (!uploadResponse.ok) {
                throw new Error("Failed to upload file");
            }

            const responseData = await uploadResponse.json();
            toast.success("File uploaded successfully:", responseData);

            if (responseData.fileUrl !== "") {
                const addPdfResponse = await fetch(`${Base_Url}/faq-add-pdf`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json", // Set content type for JSON body
                    },
                    body: JSON.stringify({ pdfpath: responseData.fileUrl }),
                });
                if (!addPdfResponse.ok) {
                    throw new Error("Failed to add PDF to FAQ");
                }
                const addedPdfData = await addPdfResponse.json();
                // toast.success("PDF added to FAQ:", addedPdfData);
                setSelectedFile(null);
                // Refresh the FAQ data after adding PDF
                getfaqPdfs();
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const deleteFaqPdf = async (id) => {
        try {
            // Display confirmation dialog
            const confirmed = window.confirm("Are you sure you want to delete this FAQ and its associated PDF?");

            // Check if user confirmed the deletion
            if (confirmed) {
                const deleteResponse = await fetch(`${Base_Url}/faq-pdfs/${id}`, {
                    method: "DELETE",
                });
                if (!deleteResponse.ok) {
                    throw new Error("Failed to delete FAQ and PDF");
                }
                toast.success("PDF deleted successfully");
                // Refresh the FAQ data after deleting
                getfaqPdfs();
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };



    return (
        <div className="p-5">
            <div className="h1 mb-4 mt-5 text-center text-dark d-flex justify-content-center align-items-center">
                <BsFillFileEarmarkPdfFill />
                <span style={{ color: '#c21717', fontSize: '24px', fontWeight: 'bold', marginLeft: '8px' }}> CSC Uploads </span>
            </div>

            {/* {showPdfViewer && selectedPdf && <PDFViewer pdfUrl={`${Base_Url}/${selectedPdf}`} onClose={handleClosePdfViewer} />} */}

            <div className="row d-flex justify-content-center mt-4 mb-4">
                <div className="col-md-10" style={{ width: "90%" }}>
                    <strong style={{ fontSize: "1.2em" }}>Uploads File</strong>
                    <div className="custom-file d-flex justify-content-center align-items-center">
                        <input type="file" className="custom-file-input" id="customFile" style={{ display: "none" }} ref={fileInputRef} onChange={handleFileChange} />
                        <label className="custom-file-label" htmlFor="customFile">
                            <strong>{selectedFile ? selectedFile.name : ""}</strong>
                        </label>
                    </div>

                    {userExists && (
                    // {true && (
                        <>
                            {selectedFile ? (
                                <button className="btn btn-success mt-2 w-100 d-flex justify-content-center align-items-center" type="button" onClick={uploadFile}>
                                    Save
                                </button>
                            ) : (
                                <button style={{ background: "#c21717", color: "white" }} className="btn  mt-2 w-100 d-flex justify-content-center align-items-center" type="button" onClick={handleUploadButtonClick}>
                                    <FaFileUpload className="mr-2" /> <span className="fw-bold">Upload PDF</span>
                                </button>
                            )}
                        </>
                    )}

                </div>
            </div>
            <Table striped bordered hover className="table-wrap">
                <thead>
                    <tr>
                        <th className="thpdf">Sr.No#</th>
                        <th className="thpdf">PDF Link</th>
                        {userExists && (
                        // {true && (
                            <>
                                <th className="thpdf">Actions</th>
                            </>
                        )}


                    </tr>
                </thead>
                <tbody>
                    {faqData && faqData.length > 0 && faqData?.map((faq, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <a className="text-primary" href={`${Base_Url}/${faq.pdf_path}`} target="_blank" rel="noreferrer">
                                    {faq.pdf_path}
                                </a>
                            </td>
                            {userExists && (
                            // {true && (
                                <>
                                    <td>
                                        <a className="text-primary" href={`${Base_Url}/${faq.pdf_path}`} target="_blank" rel="noreferrer">
                                            <FaEye style={{ cursor: "pointer" }} className="me-3 text-primary" />
                                        </a>
                                        {/* <FaEye style={{ cursor: "pointer" }} className="me-3 text-primary" onClick={() => handleOpenPdfViewer(faq.pdf_path)} /> */}

                                        <FaTrash style={{ cursor: "pointer" }} className="text-danger" onClick={() => deleteFaqPdf(faq.id)} /> {/* Trash icon */}

                                    </td>
                                </>
                            )}

                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default FaqPdfTable;
